import { z } from 'zod';
import { SchemaFormDefinition, SchemaFormFields } from '@mews-commander/form';
import { Option } from '@mews-commander/types';
import { createOption, OptimusProvider } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { AcceptedFileTypes } from './types';

const fileTypeOptions = Object.values(AcceptedFileTypes).map((fileType) =>
    createOption({
        label: fileType,
        value: fileType,
    })
);

export const attachmentsTableFilterSchema = z
    .object({
        name: z.string().optional(),
        service: z.array(z.string()).optional(),
        type: z.array(z.string()).optional(),
    })
    .partial();

export type AttachmentsTableFilterValues = z.infer<typeof attachmentsTableFilterSchema>;

const attachmentsTableFiltersFormDefinition = ({
    serviceOptions,
}: {
    serviceOptions?: Option[];
}): SchemaFormDefinition<typeof attachmentsTableFilterSchema> => ({
    fields: {
        name: {
            label: lt('ContractAttachmentNameLabel'),
        },
        service: {
            label: lt('Service'),
            field: {
                type: 'select',
                options: serviceOptions ?? [],
                showEmptyValue: false,
            },
        },
        type: {
            label: lt('ContractsFileTypeLabel'),
            field: {
                type: 'select',
                options: fileTypeOptions,
                showEmptyValue: false,
            },
        },
    },
});

export const AttachmentsTableFiltersForm = ({ serviceOptions }: { serviceOptions?: Option[] }) => (
    <OptimusProvider density="spacious">
        <SchemaFormFields
            schema={attachmentsTableFilterSchema}
            formDefinition={attachmentsTableFiltersFormDefinition({ serviceOptions })}
        />
    </OptimusProvider>
);
